<div class="header">
  <h3>ค้นหาเอกสาร</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearSearch()"></app-filter-header>

  <div class="row row-eq-height">
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="company"
          [options]="company"
          [(ngModel)]="selectedCompany"
          [autoDisplayFirst]="false"
          placeholder="บริษัท"
          [style]="{'z-index': 3}"
        >
        </p-dropdown>
        <label for="company">บริษัท</label>
      </div>

      <div class="dropdown-label-group m-t-10 d-none">
        <p-dropdown
          class="dv-dropdown"
          selectId="companyBusiness"
          [options]="homeproGroup"
          [(ngModel)]="selectedHomeproGroup"
          [autoDisplayFirst]="false"
          placeholder="ประเภทธุรกิจ"
        >
          <ng-template let-option pTemplate="item">
            {{ option }}
          </ng-template>
        </p-dropdown>
        <label for="companyBusiness">ประเภทธุรกิจ</label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          [options]="statusSearch"
          [(ngModel)]="selectedStatus"
          [autoDisplayFirst]="false"
          placeholder="สถานะ"
          [style]="{'z-index': 3}"
        >
          <ng-template let-item pTemplate="statusSearch">
            <div class="row" style="width: 100%">
              <div class="col" style="width: 50%"> {{item.label}}</div>
              <div class="col">
                <span class="label-color-dropdown" [ngClass]="{
            'label-green': item.label == 'ชำระครบหมดแล้ว' ,
            'label-red': item.label == 'ค้างชำระเต็มจำนวน' ,
            'label-orange': item.label == 'ชำระแล้วบางส่วน',
             'label-grey': item.label == 'ไม่มีการแสดงสถานะ'}"></span>
              </div>
            </div>
          </ng-template>
        </p-dropdown>
        <label for="">สถานะ</label>
      </div>

      <div class="m-t-10 d-none">
        <p-autoComplete [(ngModel)]="documentType" [disabled]="allDocType" field="type" [multiple]="true"
                        [suggestions]="typeSuggest" [size]="30" (completeMethod)="searchDocumentType($event)"
                        (onClear)="clearDocType()" class="dv-autocomplete" placeholder="ประเภทเอกสาร">
        </p-autoComplete>
      </div>
    </div>

    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="documentType"
          [options]="rdDocumentType"
          [(ngModel)]="selectedRdDocumentType"
          [autoDisplayFirst]="false"
          placeholder="ประเภทเอกสาร"
          [style]="{'z-index': 3}"
        >
        </p-dropdown>
        <label for="documentType">ประเภทเอกสาร</label>
      </div>
    </div>

  </div>
  <div class="row row-eq-height m-t-10">
    <div class="col-md-6">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          [options]="overdueStatusSearch"
          [(ngModel)]="selectedOverdueStatus"
          [autoDisplayFirst]="false"
          placeholder="สถานะการค้างจ่าย"
        >
        </p-dropdown>
        <label for="">สถานะการค้างจ่าย</label>
      </div>

      <div class="m-t-10 d-none">
        <p-autoComplete [(ngModel)]="documentType" [disabled]="allDocType" field="type" [multiple]="true"
                        [suggestions]="typeSuggest" [size]="30" (completeMethod)="searchDocumentType($event)"
                        (onClear)="clearDocType()" class="dv-autocomplete" placeholder="ประเภทเอกสาร">
        </p-autoComplete>
      </div>
    </div>
    <div class="col-md-6">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="location"
          [options]="locationSearch"
          [(ngModel)]="selectedLocation"
          [autoDisplayFirst]="false"
          placeholder="Location"
        >
        </p-dropdown>
        <label for="location">Location</label>
      </div>
    </div>
  </div>

  <div class="row row-eq-height m-t-10">
    <div class="col">
      <div class="form-label-group">
        <input class="form-control" type="text" id="searchText" [(ngModel)]="inputText" placeholder="เลขที่เอกสาร">
        <label for="searchText">เลขที่เอกสาร</label>
      </div>
    </div>

    <div class="col">
      <div class="form-label-group">
        <input class="form-control" type="text" id="searchText" [(ngModel)]="buyerNameText" placeholder="ชื่อลูกค้า">
        <label for="searchText">ชื่อลูกค้า</label>
      </div>
    </div>

    <div class="col">
      <div class="form-label-group">
        <input class="form-control" type="text" id="searchText" [(ngModel)]="buyerTaxID"
               placeholder="เลขประจำตัวผู้เสียภาษีผู้ซื้อ">
        <label for="searchText">เลขประจำตัวผู้เสียภาษีผู้ซื้อ</label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="dropdown" #dd="ngbDropdown" ngbDropdown placement="bottom-right" autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange"
                 ngbDropdownToggle placeholder="วันที่ออกเอกสาร" readonly>
          <label for="calendarDropdown">วันที่ออกเอกสาร</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">ตั้งแต่</div>
            <div class="col" style="padding-left: 30px">ถึง</div>
          </div>
          <div (click)="stopPropagation($event)">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
          </div>
        </div>
      </div>

      <div class="row align-items-center" style="height: 50%">
        <div class="col d-none">
          <p-checkbox class="dv-checkbox" [(ngModel)]="allBranch" binary="true"
                      (onChange)="selectAllBranch()"></p-checkbox>
          <!--<input type="checkbox" [(ngModel)]="allBranch" (change)="selectAllBranch()">-->
          <span>ทุกสาขา</span>
        </div>
      </div>
      <div class="row align-items-center" style="height: 50%;">
        <div class="col-md-auto d-none">
          <p-checkbox class="dv-checkbox" [(ngModel)]="allDocType" binary="true"
                      (onChange)="selectDocType()"></p-checkbox>
          <!--<input type="checkbox" [(ngModel)]="allDocType" (change)="selectDocType()">-->
          <span>ทุกประเภทเอกสาร</span>
        </div>
      </div>
    </div>

  </div>

  <div class="row" *ngIf="errorMsg">
    <div class="col text-center text-red">
      {{ errorMsg }}
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    [maxSize]="5"
    (pageChange)="pageChanged()"
    (optionChange)="searchButtonClicked()"
    *ngIf="loading === false && totalItems !== 0"
  >
    <div class="mt-3">
      <app-delete-modal *ngIf="isSystemAdmin"
          [textDeleteConfirm]="getDeleteMessageConfirm()"
          [titleText]="'ยืนยันการลบเอกสาร'"
          [disabledButton]="!canDeleteTaxDocument" [type]="invoiceDeleteType"
          [deleteMessage]="'ลบเอกสาร'" (submitted)="DeleteSelected(content2, false);">
      </app-delete-modal>
      <app-delete-modal *ngIf="!isSystemAdmin && hasRequestDeletePermission"
          [textDeleteConfirm]="getDeleteMessageConfirm(true)"
          [titleText]="'ยืนยันการขอลบเอกสาร'"
          [disabledButton]="!canDeleteTaxDocument" [type]="invoiceDeleteType"
          [confirm]="'ยืนยันการขอลบ'"
          [deleteMessage]="'ขอลบเอกสาร'" (submitted)="RequestDeleteSelected()">
      </app-delete-modal>
      <button type="button" class="btn btn-dv btn-wide"
              (click)="downloadCsvReport(loadingCsvModal)"
              *ngIf="isUIH() || isAccountant() || isAccountantAdmin() || isViewerAudit() || isSystemAdmin">
        ดาวน์โหลด CSV
      </button>
      <button type="button" class="btn btn-dv btn-wide" [disabled]="!canSendEmail"
              (click)="askEmailType(askEmailTypeModal)"
              *ngIf="isUIH() || isAccountant() || isAccountantAdmin() || isSystemAdmin || isViewer()">
        ส่ง E-mail และ SMS
      </button>
      <button type="button" class="btn btn-dv btn-wide"
              [disabled]="!canDownloadXml || selectedRdDocumentType === 'invoice' || selectedRdDocumentType === 'other' || isViewer()"
              (click)="DownloadSelected(content2, 'xml')"
              *ngIf="isUIH() || isAccountant() || isAccountantAdmin() || isViewerAudit() || isSystemAdmin">
        ดาวน์โหลด XML
      </button>
      <button type="button" class="btn btn-dv btn-wide" [disabled]="!canDownloadPdf() || isViewer()"
              (click)="DownloadSelected(content2, 'pdf')"
              *ngIf="isUIH() || isAccountant() || isAccountantAdmin() || isViewerAudit() || isSystemAdmin">
        ดาวน์โหลด PDF
      </button>
      <app-delete-modal *ngIf="isUIH() || isAccountant() || isAccountantAdmin() || isSystemAdmin"
                        [textDeleteConfirm]="'ยืนยันอีกครั้งเพื่อทำการลบเอกสาร'"
                        [titleText]="'ยืนยันการลบเอกสาร'"
                        [disabledButton]="!canDeleteInvoice" [type]="invoiceDeleteType"
                        [deleteMessage]="'ลบใบ Invoice'" (submitted)="DeleteSelected(content2); ">
      </app-delete-modal>
    </div>
  </app-custom-pagination>

  <div class="row m-t-20" *ngIf="totalItems === 0 && loading === false">
    <div class="col-12 text-center">
      <h5>ไม่พบข้อมูล</h5>
    </div>
  </div>

  <div class="m-t-20 text-center text-nowrap">
    <p-table #tt styleClass="table" *ngIf="totalItems !== 0" [loading]="loading" [style]="{'font-size': '12px'}"
             [columns]="tableCol" [value]="tableData" [customSort]="true" (onSort)="sort($event)" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">ลำดับ</th>
          <th class="px-1" *ngFor="let col of columns"  [pSortableColumn]="col.field" (click)="pageChanged()">
            {{col.header}}
            <!--<p-sortIcon [field]="col.field"></p-sortIcon>-->
          </th>
          <th *ngIf="!isAdmin()" scope="col">
            <p-checkbox class="dv-checkbox" binary="true" (onChange)="selectDeselectAll($event)"></p-checkbox>
          </th>
          <th *ngIf="isSystemAdmin">แก้ไข</th>
          <th *ngIf="!isSystemAdmin && hasRequestEditPermission">ขอแก้ไข</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex" >
        <tr>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{data.header_invoice_number}}</td>
          <td>{{data.buyer_name}}</td>
          <td style="width: 10%"><p class="with-group">{{ data.reference_ref_location }}</p></td>
          <td>
          <div>
                <p class="m-0">{{ data.header_issue_dt | date:"dd/MM/yyyy" }}</p>
                <p class="m-0 text-muted font-weight-light"
                   style="font-size: 10px">{{ data.header_issue_dt | date: "HH:mm" }}</p>
              </div>
          </td>
          <!--          <td>{{data.corporate_branch__name}}</td>-->
          <td>{{data.rd_document_type_display || data.document_type__name}}</td>
          <td>{{data.receipt_no}}</td>
          <td>{{data.total_items_total_payment.toLocaleString()}}</td>
          <td>
            <div class="status-grey" [ngClass]="{
            'status-green': data.additional_data.status === 'full_payment' ,
            'status-red': data.additional_data.status === 'full_amount_owed' ,
            'status-orange': data.additional_data.status === 'partial_payment',
            'status-cancel': data.additional_data.status === 'cancelled'}"></div>
          </td>
          <td>{{data.additional_data.overdue_balance | number}}
          <span *ngIf="data.additional_data.overdue_balance === null"> - </span>
          </td>
          <td>{{data.additional_data.due_date_diff}}
            <span *ngIf="data.additional_data.due_date_diff === null"> - </span>
            </td>
            <td>{{data.additional_data.overdue_status}}
              <span *ngIf="data.additional_data.overdue_status === null"> - </span>
              </td>
          <td>
            <i *ngIf="data.additional_data.payment_type !== null" class="fas fa-bell fa-lg pointer darkblue-color"
               (click)="openOverdueNotification(overdueModal , data)"></i>
            <i *ngIf="data.additional_data.payment_type === null" class="fas fa-bell fa-lg silver-color"></i>
          </td>
          <td>
            <i *ngIf="data.additional_data.first_email_notified
                && data.additional_data.first_sms_notified" class="far fa-check-square fa-lg darkblue-color"></i>
            <i *ngIf="!data.additional_data.first_email_notified
                && !data.additional_data.first_sms_notified" class="far fa-square fa-lg darkblue-color"></i>
          </td>
          <td>
            <i *ngIf="data.additional_data.second_email_notified
                && data.additional_data.second_sms_notified" class="far fa-check-square fa-lg darkblue-color"></i>
            <i *ngIf="!data.additional_data.second_email_notified
                && !data.additional_data.second_sms_notified" class="far fa-square fa-lg darkblue-color"></i>
          </td>
          <td>
            <div class="icon-btn d-inline">
              <i class="fas fa-comment-dots fa-lg pointer darkblue-color"
                 (click)="openCommentBox(data , commentBoxModal)"></i>
            </div>
          </td>

          <td *ngIf="!isAdmin()" style="text-align: center">
            <p-checkbox *ngIf="data.status === 'active'" class="dv-checkbox" binary="true"
                        [(ngModel)]="selectedValues[index]" (onChange)="selectIn($event,data)"></p-checkbox>
            <i *ngIf="data.status === 'cancelled'" placement="auto" container="body"
               ngbTooltip="This file has been removed" class="fas fa-exclamation-circle"></i>
          </td>
          <td *ngIf="isSystemAdmin">
            <i class="fa fa-edit fa-lg" [ngClass]="{
              'text-warning pointer': data.additional_data.overdue_balance !== null,
              'disabled': data.additional_data.overdue_balance === null
            }" (click)="openEditDocumentModal(editDocumentModal, data)"></i>
          </td>
          <td *ngIf="!isSystemAdmin && hasRequestEditPermission">
            <i class="fa fa-edit fa-lg" [ngClass]="{
              'text-warning pointer': data.additional_data.overdue_balance !== null,
              'disabled': data.additional_data.overdue_balance === null
            }" (click)="openEditDocumentModal(editDocumentModal, data)"></i>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>

<!--------------------------- COMMENT BOX MODAL--------------------->
<ng-template #commentBoxModal let-modal let-c="close" let-d="dismiss">
  <div class="modal-content chat-frame">
    <div class="modal-header border-0 comment-header-title">
      <h5 class="modal-title">กล่องข้อความ</h5>
      <button type="button" class="close" aria-label="Close" (click)="c()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="frame-body-outer">
      <div class="modal-body border-comment-outer stream-list" *ngIf="showResult">

        <div class="row comment-item"
             *ngFor="let stream of commentList">
          <div [style.background-image]="'url(' + (photo) + ')'"
               class="col-auto w-40 h-40 face-icon"
               style="background-size: cover;background-position: center;">
            <!--            STREAM PROFILE-->
          </div>
          <div class="stream">
            <div class="d-flex flex-column">
              <div class="d-flex justify-content-between">
                <div class="d-flex flex-column">
                  <div class="stream-owner">
                    {{ stream.created_username}}
                  </div>
                </div>
                <div class="flex-column d-flex justify-content-between">
                  <div class="date-time">
                    {{stream.time_since}}
                    <app-delete-modal *ngIf="isOwner(stream)" [type]="commentDeleteType"
                                      [textDeleteConfirm]="'ต้องการลบข้อความ ?'" (submitted)="deleteComment(stream.id)">
                    </app-delete-modal>
                  </div>
                </div>
              </div>
              <div class="stream-message" [innerHTML]="stream.message"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--        SEND COMMENT-->
    <div class="input-stream" *ngIf="showResult">
      <app-comment (submitted)="addComment($event)"></app-comment>
    </div>
  </div>

</ng-template>

<ng-template #content2 let-modal>
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">Alert</h4> -->
    <button type="button" class="close" aria-label="Close" [disabled]="loading_all_zip" (click)="closeDownloadAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" style="margin-bottom: 10px">
      <div *ngIf="loading_all_zip" class="col-12 text-center">
        <i class="fa fa-spinner fa-2x fa-spin" style="margin-left:5px"></i>
        <br/>
        {{allZipCurrent}} / {{allZipCount}}
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <ngb-progressbar *ngIf="loading_all_zip === true" type="info" [value]="loading_all_zip_progress"
                         height="20px"></ngb-progressbar>
        <span *ngIf="loading_all_zip === false" style="color: #4d5f7a">{{loading_all_zip_message}}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dv btn-danger btn-wide" (click)="closeDownloadAll(); searchButtonClicked();">ปิด</button>
  </div>
</ng-template>

<!--------------------------- EMAIL POPUP UPDATE--------------------->
<ng-template #askEmailTypeModal let-modal let-c="close">
  <div>
    <div class="modal-header border-0" style="margin-top: 15px">
      <div class="col d-flex">
        <h6 style="width: 100%; text-align: center">ต้องการส่งข้อความประเภทใด</h6>
        <button type="button" class="close d-flex p-2 m-r-0" (click)="closeAskEmailTypeModal()">
        <span style="font-size: 40px">&times;</span>
      </button>
      </div>
    </div>
    <div class="col text-center">
      <button type="button" class="btn btn-dv btn-wide"
              (click)="closeSendEmailSmsModal(); sendEmailSelected(sendEmailSmsModal, false)">ข้อความปกติ
      </button>
      <button type="button" class="btn btn-dv btn-wide"
              (click)="closeSendEmailSmsModal(); sendEmailSelected(sendEmailSmsModal, true)">แจ้งเกินกำหนดชำระ
      </button>
    </div>
    <br>
    <div *ngIf="paymentType" class="modal-body" style="padding-bottom: 8%">
      <div class="top-line-section"></div>

      <h6 *ngIf="paymentType === 'amount'" class="text-center">แจ้งเกินกำหนดชำระแบบ Amount</h6>
      <h6 *ngIf="paymentType === 'percentage'" class="text-center">แจ้งเกินกำหนดชำระแบบ Percentage</h6>

      <div class="d-flex justify-content-between" style="margin-left: 5%">
        <h6 class="text-left">ส่งถึง : </h6>
        <div class=" d-inline darkblue-color mr-3-rem"
             (click)="addDetailEmail()">
          <i *ngIf="resendFirstNotify || resendSecondNotify" class="fa fa-plus-circle fa-lg pointer align-self-center" aria-hidden="true"></i>
        </div>
      </div>
      <div *ngFor="let email of buyerEmail; let emailIndex = index" class="d-flex ml-2 col-12">
        <input class="form-control mt-1 send-email-disable" type="text" style="width: 91.5%"
               [(ngModel)]="email.value" [disabled]="!resendFirstNotify
               ? !resendSecondNotify
               : !resendFirstNotify && resendSecondNotify">

        <div *ngIf="emailIndex != 0" class="d-inline col-1 align-self-center"
             (click)="removeDetailEmail()">
          <i class="fas fa-trash-alt fa-lg pointer"></i>
        </div>
      </div>
      <br>
      <div class="d-flex justify-content-between" style="margin-left: 5%">
        <h6 class="text-left">CC : </h6>
      </div>
      <div *ngFor="let item of ccEmail" class="d-flex ml-2 col-11">
        <input *ngIf="paymentType" class="form-control mt-1" type="text" disabled="disabled"
               [(ngModel)]="item.ccEmailList" (change)="setDefaultCcEmail()">
      </div>
      <div class="mt-4 text-center">
        <button type="button" class="btn btn-dv width-45" [disabled]="!resendFirstNotify"
                (click)="c();resendEmailSelected(resendEmailSmsModal, true)">
          แจ้งเกินกำหนดชำระครั้งที่ 1
        </button>
        <button type="button" class="btn btn-dv width-45" [disabled]="!resendSecondNotify"
                (click)="c();resendEmailSelected(resendEmailSmsModal, false)">
          แจ้งเกินกำหนดชำระครั้งที่ 2
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #sendEmailSmsModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">ส่ง E-mail และ SMS</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeSendEmailSmsModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" style="margin-bottom: 10px">
      <div *ngIf="isSending" class="col-12 text-center">
        <i class="fa fa-spinner fa-2x fa-spin" style="margin-left:5px"></i>
        <br/>
        {{ isLoadingMessage }}
      </div>
      <div *ngIf="!isSending" class="col-12 text-center">
        {{ resendEmailSmsMessage }}
      </div>
      <div *ngIf="remark" class="col-12 text-left pb-1">
        รายการส่ง
      </div>
      <div class="col-12 text-left pb-1" *ngFor="let item of remark?.responses; let i = index">
        เอกสารเลขที่ {{ item.header_invoice_number }}
        <div *ngFor="let email of item.email_details">
          อีเมลล์: {{ email.email}} สถานะ: {{email.email_status }}
        </div>
        เบอร์: {{ item.sms_details.phone_number }} สถานะ: {{ item.sms_details.sms_status }}
      </div>
      <br>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-right p-0">
      <button type="button" class="btn btn-dv btn-wide" (click)="closeSendEmailSmsModal()">
        OK
      </button>
    </div>
  </div>
</ng-template>

<ng-template #resendEmailSmsModal let-modal let-c="close">
  <div class="modal-header">
    <h4 class="modal-title" >ส่ง E-mail และ SMS</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeAskEmailTypeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" style="margin-bottom: 10px">
      <div *ngIf="isResend" class="col-12 text-center">
        <i class="fa fa-spinner fa-2x fa-spin" style="margin-left:5px"></i>
        <br/>
        {{ isLoadingMessageResend }}
      </div>
      <div *ngIf="!isResend" class="col-12 text-center">
        {{ resendEmailSmsMessage }}
      </div>
      <br>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-right p-0" *ngIf="!isResend">
      <button *ngIf="resendEmailSmsMessage === 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง' " type="button"
              class="btn btn-dv btn-wide"
              (click)="closeAskEmailTypeModal();askEmailType(askEmailTypeModal)">
        กลับ
      </button>
      <button *ngIf="resendEmailSmsMessage === 'ส่ง E-mail และ SMS สำเร็จแล้ว'" type="button" class="btn btn-dv btn-wide"
              (click)="closeAskEmailTypeModal()">
        OK
      </button>
    </div>
  </div>
</ng-template>

<!--open notify overdue-->
<ng-template #overdueModal let-c="close">
  <div class="modal-header modal-header-color-grey">

    <div class="col mt-1">
    <h5 class="header-font-size font-weight-bold" *ngIf="paymentType === 'amount'">
      การแจ้งเตือน (ในส่วนของค่าปรับแบบ Amount)
    </h5>
      <h5 class="header-font-size font-weight-bold" *ngIf="paymentType === 'percentage'">
      การแจ้งเตือน (ในส่วนของค่าปรับแบบ Percent)
    </h5>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="closeOverdueNotification()">
      <i class="fas fa-times" style="font-size: 15px"></i>
    </button>
  </div>
  <div class="modal-body border-0">
    <div class="row">
      <div class="d-flex col" style="margin-left: 25%">
        <span>ครั้งที่ 1</span>
      </div>
      <div class="col">
        <span class="selected-icon align-self-center" [ngClass]="{ 'selected': firstEmailNotify === true }"></span>
        <span>EMAIL</span>
      </div>
    </div>
    <div class="d-flex justify-content-end mt-3" style="margin-right: 23.3%">
      <span class="selected-icon align-self-center" style="margin-right: 5px"
            [ngClass]="{ 'selected': firstSmsNotify === true }"></span>
      <span>SMS</span>
    </div>
    <div class="border-line"></div>
    <div class="row">
      <div class="d-flex col" style="margin-left: 25%">
        <span>ครั้งที่ 2</span>
      </div>
      <div class="col">
        <span class="selected-icon align-self-center" [ngClass]="{ 'selected': secondSmsNotify === true }"></span>
        <span>EMAIL</span>
      </div>
    </div>
    <div class="d-flex justify-content-end mt-3" style="margin-right: 23.3%">
      <span class="selected-icon align-self-center" style="margin-right: 5px"
            [ngClass]="{ 'selected': secondSmsNotify === true }"></span>
      <span>SMS</span>
    </div>
    <div class="border-line"></div>
    <div class="modal-footer border-0" style="margin-top: -5px">
      <div class="text-center col">
        <button class="btn btn-dv" style="border-radius: 10px !important" [disabled]="!canDownloadInvoicePdf"
          (click)="downloadAdditionalPdf()">
          <i class="fas fa-download m-r-5"></i>
          DOWNLOAD PDF
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #loadingCsvModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title">
      ดาวน์โหลดไฟล์ทั้งหมด
    </h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <i *ngIf="isLoadingCsv" class="fa fa-spinner fa-2x fa-spin" style="margin-left:5px"></i>
    {{loadingCsvMessage}}
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="c()">
      ปิด
    </button>
  </div>
</ng-template>

<ng-template #editDocumentModal>
  <div class="modal-header">
    <h5 class="modal-title" *ngIf="isSystemAdmin">
      แก้ไขเอกสาร
    </h5>
    <h5 class="modal-title" *ngIf="!isSystemAdmin && hasRequestEditPermission">
      ขอแก้ไขเอกสาร
    </h5>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body row align-items-center gx-5">
    <div class="col-md-4">
      เลขที่เอกสาร
    </div>
    <div class="col-md-8">
      <p class="form-control m-0">{{selectedDocument.header_invoice_number}}</p>
    </div>
    <div class="col-md-4 m-t-5">
      ยอดเงินคงค้างเดิม
    </div>
    <div class="col-md-8 m-t-5">
      <p class="form-control m-0">{{selectedDocument.additional_data.overdue_balance}}</p>
    </div>
    <div class="col-md-4 m-t-5">
      เปลี่ยนเป็น
    </div>
    <div class="col-md-8 m-t-5">
      <input class="form-control" type="text" [(ngModel)]="amountAfter"/>
      <ng-container *ngIf="clickedSubmit && !validDecimal(amountAfter)">
        <span class="text-red">จำนวนเงินไม่ถูกต้อง</span>
      </ng-container>
    </div>
    <div class="col-md-4 m-t-5">
      สถานะเดิม
    </div>
    <div class="col-md-8 m-t-5">
      <p class="form-control m-0">
        {{statusBefore}}
        <span class="label-color-dropdown" [ngClass]="{
            'label-green': statusBefore == 'ชำระครบหมดแล้ว' ,
            'label-red': statusBefore == 'ค้างชำระเต็มจำนวน' ,
            'label-orange': statusBefore == 'ชำระแล้วบางส่วน',
            'label-grey': statusBefore == 'ไม่มีการแสดงสถานะ'}">
        </span>
      </p>
    </div>
    <div class="col-md-4 m-t-5" *ngIf="selectedDocument?.additional_data?.status === 'partial_payment' || selectedDocument?.additional_data?.status === 'full_amount_owed'">
      เปลี่ยนเป็น
    </div>
    <div class="col-md-8 m-t-5" *ngIf="selectedDocument?.additional_data?.status === 'partial_payment' || selectedDocument?.additional_data?.status === 'full_amount_owed'">
      <p-dropdown class="custom-dropdown" [options]="statusDropdownChoices"
          [(ngModel)]="statusAfter">
        <ng-template let-item pTemplate="statusDropdownChoices">
          <div class="row" style="width: 100%">
            <div class="col" style="width: 50%"> {{item.label}}</div>
            <div class="col">
              <span class="label-color-dropdown" [ngClass]="{
                  'label-green': item.label == 'ชำระครบหมดแล้ว' ,
                  'label-red': item.label == 'ค้างชำระเต็มจำนวน' ,
                  'label-orange': item.label == 'ชำระแล้วบางส่วน',
                  'label-grey': item.label == 'ไม่มีการแสดงสถานะ'}">
              </span>
            </div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <div class="col-md-4 m-t-5"></div>
    <div class="col-md-8 m-t-5">
      <span class="text-red" *ngIf="clickedSubmit && !validAmountAfterAndStatusAfter(amountAfter, statusAfter)">
        จะเปลี่ยนสถานะเป็นชำระครบหมดแล้วได้ก็ต่อเมื่อยอดเป็น 0 เท่านั้น
      </span>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-dv btn-wide" (click)="openConfirmModal(confirmActionModal)">
      บันทึก
    </button>
    <button class="btn btn-outline-secondary" (click)="closeModal()">
      ยกเลิก
    </button>
  </div>
</ng-template>

<ng-template #confirmActionModal>
  <div class="modal-header">
    <h5 class="modal-title" *ngIf="isSystemAdmin">
      ยืนยันแก้ไขเอกสาร
    </h5>
    <h5 class="modal-title" *ngIf="!isSystemAdmin && hasRequestEditPermission">
      ยืนยันขอแก้ไขเอกสาร
    </h5>
    <button type="button" class="close" aria-label="Close" (click)="closeConfirmModal()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body" *ngIf="isSystemAdmin">คุณแน่ใจหรือไม่ที่จะแก้ไขเอกสารฉบับนี้ ({{selectedDocument.header_invoice_number}})</div>
  <div class="modal-body" *ngIf="!isSystemAdmin && hasRequestEditPermission">คุณแน่ใจหรือไม่ที่จะขอแก้ไขเอกสารฉบับนี้ ({{selectedDocument.header_invoice_number}})</div>
  <div class="modal-footer">
    <button class="btn btn-dv btn-wide" *ngIf="isSystemAdmin" (click)="editDocument()">
      ยืนยัน
    </button>
    <button class="btn btn-dv btn-wide" *ngIf="!isSystemAdmin && hasRequestEditPermission" (click)="requestEditDocument()">
      ยืนยัน
    </button>
    <button class="btn btn-outline-secondary" (click)="closeConfirmModal()">
      ยกเลิก
    </button>
  </div>
</ng-template>


// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search.component.html